/**
 * Leaderboard Hooks
 * React hooks for fetching leaderboard data
 */
import { getLeaderboard } from '../Services/leaderboard';
import { ToplistConfig } from '../Types/leaderboard';
import { useBizQuery } from './useBizQuery';

const QUERYKEY_LEADERBOARD = 'LEADERBOARD';

/**
 * Hook to fetch leaderboard data based on configuration
 * @param config - Configuration object with scope, dates, and limit
 * @returns Leaderboard data and status state
 */
export const useLeaderboard = (config: ToplistConfig) => {
	const { scope, fromDate, toDate, limit = 10 } = config;

	// Create a unique query key based on the configuration
	const queryKey = [
		QUERYKEY_LEADERBOARD,
		scope,
		limit,
		fromDate?.toISOString() ?? 'all-time',
		toDate?.toISOString() ?? 'all-time',
	];

	const { data, statusState, errorType, refetch } = useBizQuery(
		queryKey,
		() => getLeaderboard(scope, limit, fromDate, toDate),
		true, // enabled
		60 // staleTime in seconds
	);

	return {
		leaderboard: data ?? [],
		statusState,
		errorType,
		refetch,
	};
};
